<template>
  <div class="practice container">
    <el-tabs
      type="border-card"
      v-model="activeName"
      @tab-click="handleTabClick"
    >
      <el-tab-pane label="实战手册" name="1" v-if="info.sz">
        <div class="box">
          <el-form
            :model="params"
            class="search_form"
            :inline="true"
            size="small"
          >
            <el-form-item prop="title">
              <el-input v-model="params.title" placeholder="搜索"
                ><el-button
                  slot="append"
                  size="small"
                  icon="el-icon-search"
                  @click="getList"
                ></el-button
              ></el-input>
            </el-form-item>
            <el-form-item prop="taskType">
              <el-radio-group v-model="params.taskType" @change="getList">
                <el-radio-button :label="null">全部</el-radio-button>
                <el-radio-button label="PERSONAL">个人</el-radio-button>
                <el-radio-button label="TEAM">团队</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <el-table
            class="practice_list"
            :data="list"
            height="calc(100% - 50px - 32px - 20px)"
          >
            <el-table-column prop="title" label="实战名称"> </el-table-column>
            <el-table-column
              prop="worksStatus"
              width="100"
              label="状态"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  type="success"
                  size="medium"
                  v-show="scope.row.worksStatus == 'SUBMITTED'"
                  >已提交</el-tag
                >
                <el-tag
                  type="warning"
                  size="medium"
                  v-show="!scope.row.worksStatus"
                  >未完成</el-tag
                >
                <el-tag
                  type="danger"
                  size="medium"
                  v-show="scope.row.worksStatus == 'REDO'"
                  >被打回</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="taskType"
              width="100"
              label="类型"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="虚拟仿真" name="2" v-if="info.mock" lazy>
        <div class="box" style="display: flex">
          <iframe class="pdf" :src="info.mockPdf"></iframe>
          <div class="right-box">
            <el-alert
              title="提示"
              type="warning"
              description="虚拟仿真仅第一次操作产生成绩，后续可继续进行模拟训练，但不产生成绩，操作成绩被老师打回后可重新产生成绩，请谨慎操作"
              :closable="false"
            >
            </el-alert>
            <el-button-group style="margin-top: 30px">
              <el-button type="info" v-if="!mockInfo" disabled
                >未提交</el-button
              >
              <el-button
                type="success"
                v-else-if="mockInfo.status == 1"
                disabled
                >已提交</el-button
              >
              <el-button
                type="danger"
                v-else-if="mockInfo.status == -1"
                disabled
                >被打回</el-button
              >
              <el-button type="primary" @click="goMock">开始实训</el-button>
            </el-button-group>

            <p class="score-row" v-if="mockInfo.status == 1">
              得分：<span>{{ mockInfo.score }}</span> 分
            </p>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="评价工具" name="3" v-if="info.teamGrade" lazy>
        <div
          v-if="gradeStatus == 0"
          style="
            padding: 80px 0;
            height: calc(100vh - 60px - 59px - 60px - 60px);
          "
        >
          <empty-status desc="评分尚未开始" />
        </div>
        <team-grade ref="grade" v-else />
      </el-tab-pane>
      <el-tab-pane
        label="英雄榜"
        name="4"
        v-if="info.teamGrade && gradeStatus == 1"
      >
        <ranking-list ref="rankingList" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { practiceList } from "@/api/practice";
import { mockInfo } from "@/api/chapterMock";
import { getGradeStatus } from "@/api/teamGrade";
import TeamGrade from "./teamGrade.vue";
import EmptyStatus from "@/components/emptyStatus";
import RankingList from "./rankingList.vue";

export default {
  props: {
    info: Object,
  },
  components: {
    TeamGrade,
    EmptyStatus,
    RankingList,
  },
  data() {
    return {
      activeName: "1",
      params: {
        title: "",
        classId: this.$route.query.id,
        classChapterId: this.$route.query.classChapterId,
        taskType: null,
      },
      list: [],
      mockInfo: {},
      gradeStatus: 0,
    };
  },
  created() {
    this.getList();
    this.getStatus();
    this.handleVisibilitychange = () => {
      !document.hidden && this.getMockInfo();
    };

    window.addEventListener("visibilitychange", this.handleVisibilitychange);
  },
  beforeDestroy() {
    window.removeEventListener("visibilitychange", this.handleVisibilitychange);
  },
  // watch: {
  //   $route(val) {
  //     this.params.classId = val.query.id;
  //     this.params.classChapterId = val.query.classChapterId;
  //     this.getList();
  //     this.getChapter();
  //     this.getStatus();
  //   },
  // },
  methods: {
    getMockInfo() {
      console.log("hhh");
      mockInfo(this.$route.query.classChapterId).then((res) => {
        this.mockInfo = res.data;
      });
    },
    //   列表
    getList() {
      this.params.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      practiceList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatter(row) {
      if (row.taskType == "PERSONAL") {
        return "个人";
      } else if (row.taskType == "TEAM") {
        return "团队";
      } else {
        return "默认";
      }
    },
    handleDetail(row) {
      if (row.taskStoreId == 0)
        this.$router.push({
          path: "/courseDetail/practice/pdf",
          query: {
            ...this.$route.query,
            taskId: row.taskId,
            worksStatus: row.worksStatus,
            worksId: row.worksId,
          },
        });
      else
        this.$router.push({
          path: "/courseDetail/practice/detail",
          query: { ...this.$route.query, taskId: row.taskId },
        });
    },
    handleCheck(path) {
      const { href } = this.$router.resolve({
        path,
      });
      window.open(href, "_blank");
    },
    handleTabClick(tab) {
      if (tab.name == 2) {
        this.getMockInfo();
      } else if (tab.name == 4) {
        this.$refs.rankingList.getRanking()
      }
    },
    goMock() {
      let href;
      if (this.info.mockType == 1) {
        href = "/student/simulation/phone?type=0";
      } else if (this.info.mockType == 2) {
        href = "/student/simulation/doudian/login";
      } else if (this.info.mockType == 3) {
        href = "/student/simulation/qianchuan";
      } else if (this.info.mockType == 4) {
        href = "/student/simulation/phone?type=1";
      } else if (this.info.mockType == 5) {
        href = "/student/simulation/phone?type=3";
      } else if (this.info.mockType == 6) {
        href = "/student/simulation/buyin/live/goods";
      } else if (this.info.mockType == 7) {
        href = "/student/simulation/buyin/live/provide";
      } else if (this.info.mockType == 8) {
        href = "/student/simulation/phone?type=2";
      }
      if (href) {
        localStorage.setItem("mockChapterId", this.$route.query.classChapterId);
        window.open(href, "_blank");
      }
    },
    getStatus() {
      getGradeStatus({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          if (res.code == 0) {
            this.gradeStatus = res.data;
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.practice {
  margin: 30px auto;
  height: 100%;
  text-align: left;
  .box {
    // padding: 25px 35px;
    height: calc(100vh - 60px - 59px - 60px - 60px);
    background-color: #fff;
    .pdf {
      flex: 1;
      border: none;
    }
    .right-box {
      margin-left: 10px;
      width: 200px;
      text-align: center;
      .score-row {
        margin-top: 30px;
        color: #f56c6c;
        span {
          font-size: 28px;
          font-weight: bold;
        }
      }
    }
    ::v-deep .search_form {
      .el-form-item {
        margin-right: 50px;
        .el-input-group__append {
          background-color: #409eff;
          border-color: #409eff;
          color: #fff;
        }
      }
    }
    ::v-deep .practice_list {
      margin-top: 5px;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }
  }
}
</style>